/* esm.sh - rxjs@7.8.1/dist/esm/internal/symbol/observable */
var o=typeof Symbol=="function"&&Symbol.observable||"@@observable";export{o as observable};
//# sourceMappingURL=observable.mjs.map